import React from 'react'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import Component from './Component'

export const EntitlementsContext = React.createContext({
  attributeAccessible: () => false,
  attributeInaccessible: () => true
})

export default class EntitlementProvider extends Component {
  static propTypes = {
    entitlements: PropTypes.object
  }

  get permittedAttributes() {
    return get(this.props.entitlements, 'permitted_attributes', [])
  }

  get contextValue() {
    return {
      attributeAccessible: this.attributeAccessible,
      attributeInaccessible: this.attributeInaccessible
    }
  }

  attributeAccessible = (attribute) => {
    return this.permittedAttributes.includes(attribute)
  }

  attributeInaccessible = (attribute) => {
    return !this.attributeAccessible(attribute)
  }

  render() {
    return (
      <EntitlementsContext.Provider value={this.contextValue}>
        {this.props.children}
      </EntitlementsContext.Provider>
    )
  }
}
